import { lazyLoad } from 'utils/loadable';

export const KyashConfigPage = lazyLoad(
  () => import('./index'),
  module => module.KyashConfigPage,
);
